export default "__VITE_ASSET__A8ciulsE__"